const Emoji_0 = {
    ';)': { id: 2, width: 18, height: 18, tags: 'wink' },
    ':_)': { id: 6, width: 18, height: 18, tags: 'cry' },
    ':_d': { id: 6, width: 18, height: 18 },
    ':_D': { id: 6, width: 18, height: 18, tags: 'grin' },
    ':-)': { id: 610, width: 18, height: 18, tags: 'smile' },
    ':-*': { id: 64, width: 18, height: 18, tags: 'kiss' },
    ':-$': { id: 37, width: 18, height: 18 },
    ':-D': { id: 6, width: 18, height: 18 },
    ':-d': { id: 6, width: 18, height: 18 },
    ':?': { id: 46, width: 18, height: 18 },
    ':(': { id: 26, width: 18, height: 18 },
    ':)': { id: 1, width: 18, height: 18 },
    ':*': { id: 64, width: 18, height: 18 },
    ':|': { id: 18, width: 18, height: 18 },
    ':$': { id: 589, width: 42, height: 25 },
    ':08': { id: 67, width: 20, height: 21 },
    ':1': { id: 69, width: 20, height: 20 },
    ':1eye': { id: 68, width: 20, height: 24 },
    ':2': { id: 70, width: 20, height: 22 },
    ':34': { id: 71, width: 30, height: 26 },
    ':48': { id: 72, width: 20, height: 21 },
    ':49': { id: 73, width: 20, height: 21 },
    ':59': { id: 74, width: 28, height: 26 },
    ':838261': { id: 75, width: 19, height: 19, tags: 'shy' },
    ':D': { id: 6, width: 18, height: 18 },
    ':d': { id: 6, width: 18, height: 18 },
    ':G': { id: 260, width: 25, height: 23 },
    ':g': { id: 260, width: 25, height: 23 },
    ':o)': { id: 4, width: 18, height: 18 },
    ':P': { id: 11, width: 18, height: 18 },
    ':p': { id: 11, width: 18, height: 18 },
    ':v': { id: 535, width: 25, height: 23 },
    ':x': { id: 42, width: 18, height: 18 },
    '(:': { id: 9, width: 18, height: 18 },
    '=;': { id: 27, width: 20, height: 20, tags: 'eyebrows' },
    '=]': { id: 34, width: 18, height: 18, tags: 'sideways' },
    '=o/': { id: 604, width: 23, height: 10 },
    '8)': { id: 12, width: 18, height: 18, tags: 'cool,glasses' },
    '8d': { id: 5, width: 18, height: 18 },
    '8D': { id: 5, width: 18, height: 18, tags: 'amazed,astonished,ecstatic' },
}

export default Emoji_0
